import { __assign, __awaiter, __generator } from "tslib";
import { Loader } from '@anex/common';
import { Field, Form, Formik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import * as Yup from 'yup';
import { Error } from '../../../components';
export var NotAvailable = inject('api', 'addressParser', 'checkAddressStore')(observer(function (props) {
    var _a = React.useState({
        loading: false,
        requestSent: false,
    }), state = _a[0], setState = _a[1];
    var checkAddressStore = props.checkAddressStore, api = props.api, addressParser = props.addressParser;
    var registerDetails = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var address, emailAddress, fullName, phoneNumber, req;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    address = checkAddressStore.formattedAddress;
                    emailAddress = values.emailAddress, fullName = values.fullName, phoneNumber = values.phoneNumber;
                    req = {
                        address: address,
                        emailAddress: emailAddress,
                        fullName: fullName,
                        phoneNumber: phoneNumber,
                    };
                    setState(__assign(__assign({}, state), { loading: true }));
                    return [4, api.V1.Sale.Broadband.RegisterDetails(req)];
                case 1:
                    _a.sent();
                    setState({ requestSent: true, loading: false });
                    return [2];
            }
        });
    }); };
    var onRetryClick = props.onRetryClick;
    var registerDetailsSchema = Yup.object().shape({
        emailAddress: Yup.string()
            .required('Please enter your email address')
            .email('Invalid email address'),
        fullName: Yup.string()
            .required('Please enter your full name')
            .matches(/[^\s].*/, 'Please enter a valid full name'),
        phoneNumber: Yup.mixed().when('phoneType', function (value) {
            if (value === void 0) { value = 'mobile'; }
            var validateType = new Map([
                [
                    'mobile',
                    Yup.string()
                        .required('Please enter a valid phone number')
                        .matches(/^04[0-9]{8}$/, 'Please enter a valid mobile phone number'),
                ],
                [
                    'home',
                    Yup.string()
                        .required('Please enter a valid phone number')
                        .matches(/^0(2|3|7|8)[0-9]{8}$/, 'Please enter a valid home phone number'),
                ],
                [
                    'work',
                    Yup.string()
                        .required('Please enter a valid phone number')
                        .matches(/^0(2|3|4|7|8)[0-9]{8}$/, 'Please enter a valid work phone number'),
                ],
            ]);
            return validateType.get(value);
        }),
        phoneType: Yup.string().required('Please select a phone type'),
    });
    var formikProps = {
        initialValues: {
            emailAddress: '',
            fullName: '',
            phoneNumber: '',
            phoneType: 'mobile',
        },
        onSubmit: function (values) {
            registerDetails(values);
        },
        render: function (_a) {
            var handleSubmit = _a.handleSubmit, isSubmitting = _a.isSubmitting, errors = _a.errors, touched = _a.touched;
            return (React.createElement(Form, null,
                React.createElement("h3", null, "There are currently no available service at your address."),
                React.createElement("span", null, "If you register your details below, we'll contact you when the nbn\u2122 is ready at your place."),
                React.createElement("div", { className: "nbn-service-details" },
                    React.createElement("br", null),
                    React.createElement("strong", { style: { fontWeight: 'bold' } }, "Your address"),
                    React.createElement("br", null),
                    React.createElement("span", { className: "address" },
                        checkAddressStore.formattedAddress,
                        React.createElement("button", { type: "button", className: "btn btn-link text-highlight btn-inline-block", onClick: onRetryClick }, "Check another address"))),
                React.createElement("div", { className: "form__wrap form__wrap_inner form__wrap_inner_last" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-6" },
                            React.createElement("label", { htmlFor: "fullName" }, "Your full name"),
                            React.createElement(Field, { id: "fullName", name: "fullName", component: "input", className: "form-control shadow-alt " + (errors.fullName &&
                                    touched.fullName &&
                                    'error'), placeholder: "Full name" }),
                            React.createElement(Error, { name: "fullName" })),
                        React.createElement("div", { className: "col-md-6" },
                            React.createElement("label", { htmlFor: "phoneNumber" }, "Your phone number"),
                            React.createElement("div", { className: "input-group" },
                                React.createElement("div", { className: "input-group-btn" },
                                    React.createElement("div", { className: "select-pinned pinned-left" },
                                        React.createElement(Field, { id: "phoneType", name: "phoneType", component: "select", className: "form-control", style: { minWidth: '120px' } },
                                            React.createElement("option", { value: "mobile" }, "Mobile"),
                                            React.createElement("option", { value: "home" }, "Home"),
                                            React.createElement("option", { value: "work" }, "Work")))),
                                React.createElement(Field, { id: "phoneNumber", name: "phoneNumber", component: "input", className: "form-control shadow-alt " + (errors.phoneNumber &&
                                        touched.phoneNumber &&
                                        'error'), placeholder: "Phone" })),
                            React.createElement(Error, { name: "phoneNumber" })))),
                React.createElement("br", null),
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { htmlFor: "emailAddress" }, "Email address"),
                    React.createElement(Field, { id: "emailAddress", name: "emailAddress", component: "input", className: "form-control shadow-alt " + (errors.emailAddress &&
                            touched.emailAddress &&
                            'error') }),
                    React.createElement(Error, { name: "emailAddress" })),
                React.createElement("br", null),
                React.createElement("div", { className: "row" },
                    React.createElement("button", { type: "submit", className: "btn btn-feature2 btn-block", onClick: handleSubmit, disabled: isSubmitting }, isSubmitting ? 'Submitting' : 'Submit'))));
        },
        validationSchema: registerDetailsSchema,
    };
    return (React.createElement("div", { className: "panel service-query-result" },
        React.createElement(Loader, { loading: state.loading }),
        state.requestSent && (React.createElement(React.Fragment, null,
            React.createElement("h3", null, "Thanks for registering"),
            React.createElement("p", null, "Thanks for registering your details with us. We'll be in touch when nbn\u2122 is available in your area."))),
        !state.requestSent && React.createElement(Formik, __assign({}, formikProps))));
}));
//# sourceMappingURL=NotAvailable.js.map